import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdbcfdb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-2 select-type" }, "Select your preferred profile type for system registration", -1))
const _hoisted_2 = { class: "p-d-flex p-mt-6" }
const _hoisted_3 = {
  key: 0,
  class: "material-icons p-ml-4 mui"
}
const _hoisted_4 = {
  key: 1,
  class: "circle p-ml-4 p-mt-5"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-ml-3 p-mt-5 type-text" }, "Influencer", -1))
const _hoisted_6 = {
  key: 0,
  class: "material-icons p-ml-4 mui"
}
const _hoisted_7 = {
  key: 1,
  class: "circle p-ml-4 p-mt-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-ml-3 p-mt-5 type-text" }, "Brand", -1))
const _hoisted_9 = {
  key: 0,
  class: "p-mt-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "material-icons mui-tips" }, "tips_and_updates"),
  /*#__PURE__*/_createElementVNode("div", { class: "registration-text p-mt-2 p-ml-3" }, "Influencer registration")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "registration-description p-mt-4" }, "Registering as an influencer gives you access to campaigns published by gaming companies, developers and publishers. Earn money by applying to campaigns and delivering meaningful content", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "p-mt-4"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "material-icons mui-tips" }, "tips_and_updates"),
  /*#__PURE__*/_createElementVNode("div", { class: "registration-text p-mt-2 p-ml-3" }, "Brand registration")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "registration-description p-mt-4" }, "Registering as a brand allows you to create and run your own influencer marketing campaigns. Connect with thousands of ambitious micro and macro gaming influencers and promote your games through performance driven campaigns.", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.selection = 'creator'; _ctx.active = 1}),
        class: _normalizeClass([_ctx.selection === 'creator' ? 'registration-box-influencer-active' : 'registration-box-influencer'])
      }, [
        (_ctx.active === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "check_circle"))
          : (_openBlock(), _createElementBlock("div", _hoisted_4)),
        _hoisted_5
      ], 2),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.selection = 'brandOwner'; _ctx.active = 2}),
        class: _normalizeClass([_ctx.selection === 'brandOwner' ? 'registration-box-brand-active' : 'registration-box-brand'])
      }, [
        (_ctx.active === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "check_circle"))
          : (_openBlock(), _createElementBlock("div", _hoisted_7)),
        _hoisted_8
      ], 2)
    ]),
    (_ctx.selection === 'creator')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.selection === 'brandOwner')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
      : _createCommentVNode("", true)
  ], 64))
}